// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"fe29cc10","218":"146d9995","453":"eb570f4f","566":"6809a7ba","577":"3d8390a1","657":"b977cea3","803":"aaa8b063","849":"f58c46d6","890":"74b89e3e"}[chunkId] + ".chunk.js";
};